import React from "react";
import { Printer, Package, Layers, Copy, Truck } from "lucide-react";
import { IMAGES } from "../lib/site";
import { Reveal } from "../components/Reveal";
import { PageHero, SectionHeader, CTAButton, useSeo } from "../components/Shared";

const SECTIONS = [
  { icon: Printer, t: "Print and Signage", d: "Brochures, handouts, presentation materials, and signage produced for your program." },
  { icon: Package, t: "Event-Specific Kits", d: "Materials assembled into ready-to-use kits for a specific event or audience." },
  { icon: Layers, t: "Assembly and Packaging", d: "Collation, packaging, and assembly so materials arrive complete and presentation-ready." },
  { icon: Copy, t: "Version and Quantity Coordination", d: "Manage multiple versions and quantities across teams, regions, or events." },
  { icon: Truck, t: "Storage, Fulfillment and Distribution", d: "Store collateral and ship it where it's needed — connected to MJG fulfillment." },
];

export default function MarketingCollateral() {
  useSeo(
    "Marketing Collateral Fulfillment | MJG Promotions",
    "Printing, signage, event kits, packaging, assembly, storage, and distribution — marketing collateral kitted and ready to go, from MJG Promotions in Fairfield, NJ."
  );
  return (
    <>
      <PageHero
        eyebrow="Marketing Collateral"
        title="Marketing Collateral, Kitted and Ready to Go"
        intro="MJG supports brochures, signage, handouts, presentation materials, event-specific kits, packaging, assembly, fulfillment, and shipping — every piece connected back to inventory and event readiness."
        image={IMAGES.collateral}
      />

      <section className="bg-white py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5">
          <div className="grid gap-12 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <SectionHeader eyebrow="Print to Delivery" title="Every Piece, Accounted For" body="We connect every print and collateral service back to inventory and event readiness — so nothing gets over-ordered, lost, or left behind." />
              <img src={IMAGES.brochures} alt="Printed marketing brochures and collateral" className="mt-8 aspect-[4/3] w-full rounded-sm object-cover" loading="lazy" />
              <CTAButton to="/contact" testId="collateral-cta" variant="primary">Plan Your Collateral Program</CTAButton>
            </div>
            <div className="lg:col-span-7">
              <div className="grid gap-px overflow-hidden border border-brand-line bg-brand-line sm:grid-cols-2">
                {SECTIONS.map((s, i) => (
                  <Reveal key={s.t} delay={(i % 2) * 0.06}>
                    <div className="group h-full bg-brand-warm p-7 transition-colors hover:bg-white">
                      <s.icon className="h-7 w-7 text-brand-red" aria-hidden="true" />
                      <h3 className="mt-5 text-lg font-bold text-brand-black">{s.t}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-brand-gray">{s.d}</p>
                    </div>
                  </Reveal>
                ))}
                <div className="hidden bg-brand-red p-7 sm:block">
                  <p className="text-lg font-bold leading-snug text-white">Everything your brand needs — under one roof.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
